import { render, staticRenderFns } from "./smsconfiguration.vue?vue&type=template&id=2b8c6948&scoped=true"
import script from "./smsconfiguration.vue?vue&type=script&lang=js"
export * from "./smsconfiguration.vue?vue&type=script&lang=js"
import style0 from "./smsconfiguration.vue?vue&type=style&index=0&id=2b8c6948&prod&lang=less&scoped=true"
import style1 from "./smsconfiguration.vue?vue&type=style&index=1&id=2b8c6948&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c6948",
  null
  
)

export default component.exports